import { Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-close',
  templateUrl: './close.component.html'
})
export class CloseComponent implements OnInit {

  faTimes = faTimes;

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { }

  ngOnInit(): void {
    
  }

  close() {
    this.store.dispatch(new actions.Close());
  }
  
}
